// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3rqIr","paramInput":"JobSimulator_paramInput__CzIsO","input":"JobSimulator_input__3Zgc3"};